/**
 * Default form handler for widget forms.
 */
$(function() {
	$('.widgetForm form, .widgetSimpleForm form').each(function(idx, form) { submitTo(form, formhandle); });
	
	function formhandle(form) {
		// Create submit handler for contact form
		var f = $(form),
			$btn = $('button', f),
			isBtn = $btn.length > 0,
			orig = 'Send';
		
		// remove previous error messages
		$('.error', f).remove();
		
		if(isBtn) {
			orig = $btn.html();
			$btn.html('Vent');
		} else {
			$btn = $('input[type=submit]', f);
			orig = $btn.val();
			$btn.val('Vent');
		}

		$btn.attr('disabled','disabled');
		
		var formid = $('input[name=formid]', f).val();
		
		var $primary = $('input[name=kom_primary]', f),
			pval = $primary.val();
		if(pval != undefined) {
			pval = btoa(pval + formid);
			$primary.val(pval);
		}
		var $secondary = $('input[name=kom_secondary]', f),
			sval = $secondary.val();
		if(sval != undefined) {
			sval = btoa(sval + formid);
			$secondary.val(sval);
		}
		
		$.post(f.attr('action'), 
				f.serialize(), 
				function(data) { // success
					f.closest('.widgetElement').addClass('contenda-formSuccess');
				}, 'json')
			.fail(function(data) { // error
				f.prepend('<li class="error">Der skete en fejl: '+Contenda.t(data.responseText)+'</li>');
				$btn.removeAttr('disabled');
				
				isBtn ? $btn.html(orig) : $btn.val(orig);
		});
	}
	
});